import { keyframes } from "@emotion/core";
import { wobble as _wobble } from "react-animations";

export const wobble = keyframes`${_wobble}`;
